module.exports = "<div [class.active]=\"state\"class=\"loader-wrapper\">\n  <div class=\"loader-container\">\n    <div class=\"loader\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/loader/loader.component.html
// module id = 708
// module chunks = 0